module.exports = __webpack_public_path__ + "static/media/miss.fef6b1aa.mp3";